module.exports = __webpack_public_path__ + "img/B7A763_E6E1CC_554A1E_6C6428-256px.d51e74f5.png";